import React from 'react';
import { Minus, Plus, Type } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import Tooltip from './ToolTip';

interface FontSizeToggleProps {
  className?: string;
}

export const FontSizeToggle: React.FC<FontSizeToggleProps> = ({ className = '' }) => {
  const { fontSize, setFontSize } = useTheme();

  const fontSizes = [
    { value: 'small' as const, icon: Minus, label: 'Small' },
    { value: 'medium' as const, icon: Type, label: 'Medium' },
    { value: 'large' as const, icon: Plus, label: 'Large' },
  ];

  const getCurrentFontSize = () => {
    return fontSizes.find(f => f.value === fontSize) || fontSizes[1];
  };

  const cycleFontSize = () => {
    if (fontSize === 'small') {
      setFontSize('medium');
    } else if (fontSize === 'medium') {
      setFontSize('large');
    } else {
      setFontSize('small');
    }
  };

  const currentFontSize = getCurrentFontSize();
  const CurrentIcon = currentFontSize.icon;

  return (
    <Tooltip message={`Text Size: ${currentFontSize.label}. Click to change.`}>
      <button
        onClick={cycleFontSize}
        className={`
        p-2 rounded-md transition-all duration-200 bg-gray-100 dark:bg-gray-800
        text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white
        ${className}
      `}
        // title={`Font Size: ${currentFontSize.label}. Click to change.`}
      >
        <CurrentIcon className="w-4 h-4" />
      </button>
    </Tooltip>
  );
};

export default FontSizeToggle;
